import { useCallback } from "react";
import { useAppSelector } from "../redux/hooks";

const acosOrRoas = <T>(preferences: { acos_or_roas?: string }, acos: T, roas: T) =>
  preferences.acos_or_roas === "roas" ? roas : acos;

export const useAcosOrRoas = () => {
  const preference = useAppSelector((state) => state.user.preferences.acos_or_roas);
  return useCallback(
    <T>(acos: T, roas: T) => {
      return preference === "roas" ? roas : acos;
    },
    [preference],
  );
};

export default acosOrRoas;
